export class Contact {
  fullName: string;                                                                                                                       
  email: string;
  subject: string;
  details: string;
}
